import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Route is /organizations/$organizationId/subscription: the legacy path of the
 * organization billing page. It permanently forwards to /billing (the canonical route)
 * so existing bookmarks and links — and any post-provision redirect that still points
 * here — keep resolving; the page itself lives at the new path.
 */
export const Route = createFileRoute("/_app/organizations/$organizationId/subscription")({
  beforeLoad: ({ params }) => {
    throw redirect({
      params: { organizationId: params.organizationId },
      to: "/organizations/$organizationId/billing",
    });
  },
});
